import styles from "./VacanciesBlock.module.scss";
import { LinkProps } from "src/base-props/LinkProps";
import IconMS from "src/components/utils/IconMS/IconMS";

export interface VacanciesBlockItem {
  deadline: string;
  title: {
    externalLinkDomain?: string;
    target?: string;
    text?: string;
    description?: string;
    href: string;
    isExternal?: boolean;
  };
  type: string;
}

export interface VacanciesBlockProps {
  deadlineLabel: string;
  heading: string;
  typeLabel: string;
  vacancies: VacanciesBlockItem[];
  noVacancies?: string;
}

const VacanciesBlock: React.FC<VacanciesBlockProps> = ({
  deadlineLabel,
  heading,
  typeLabel,
  noVacancies,
  vacancies,
}) => {
  
  return (
    <div className={styles.vacanciesBlock}>
      <h2>{heading}</h2>
      <ul>
        {vacancies.length === 0 ? (
          <li className={styles.emptyContainer}>
            {noVacancies && (
              <p>
                <em>{noVacancies}</em>
              </p>
            )}
          </li>
        ) : (
          vacancies.map((position, index) => (
            <li key={index}>
              <a href={position.title.href} target={position.title.target}>
                <div className={styles.position}>
                  <span>{position.title.text}</span>
                  <IconMS
                    className={styles.icon}
                    name="open_in_new"
                    size="15px"
                  />
                </div>
                <div className={styles.detailsContainer}>
                  <div className={styles.detail}>
                    <span className={styles.label}>{typeLabel}</span>
                    <span>{position.type}</span>
                  </div>
                  <div className={styles.detail}>
                    <span className={styles.label}>{deadlineLabel}</span>
                    <span>{position.deadline}</span>
                  </div>
                </div>
              </a>
            </li>
          ))
        )}
      </ul>
    </div>
  );
};

export default VacanciesBlock;
